import * as React from 'react';
import { ICON_NAME, Icon } from '../icon';

import './accordion-item.styles.less';

const icon: JSX.Element = <Icon name={ICON_NAME.ANGLE_DOWN} />;

export default class AccordionItem extends React.PureComponent<IAccordionItemProps> {
    public render(): JSX.Element {
        const {
            id,
            heading,
            panel,
            isOpen,
            onClick
        } = this.props;

        return (
            <div className={`sitegen-accordion-item ${isOpen ? 'sitegen-accordion-item--active' : ''}`}>
                <div
                    className="sitegen-accordion-item__heading"
                    onClick={() => onClick(id)}
                >
                    <div className="sitegen-accordion-item__title">{heading}</div>
                    <div className="sitegen-accordion-item__icon">{icon}</div>
                </div>

                {isOpen && <div className="sitegen-accordion-item__panel">
                    <div className="sitegen-accordion-item__text">{panel}</div>
                </div>}
            </div>
        );
    }
}

interface IAccordionItemProps {
    readonly id: number;
    readonly isOpen: boolean;
    readonly [key: string]: React.ReactNode;
    readonly onClick: (id: number) => void;
}

export {
    Icon,
    IAccordionItemProps
};
